import { render } from "./PublicReviewRequest.vue?vue&type=template&id=17da9e3c&scoped=true"
import script from "./PublicReviewRequest.vue?vue&type=script&lang=js"
export * from "./PublicReviewRequest.vue?vue&type=script&lang=js"

import "./PublicReviewRequest.vue?vue&type=style&index=0&id=17da9e3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17da9e3c"]])

export default __exports__